"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldUpdateParent = exports.getValidDate = exports.getInitialState = exports.buildDateResponseObject = exports.allInputsTouched = exports.allInputsHaveValues = void 0;
var _every = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/every"));
var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));
var _validation = require("./validation");
/**
 * @typedef {{value: String, initialValue: String, touched: Boolean, error: String, isErrorVisible: Boolean, lastEventType: String}} InputState
 */

/**
 * This will generate an initial state for a given input based on the config
 * passed in from the consumer of the input.
 *
 * @param {Object} config The config object for a given input
 * @param {String} inputType One of [MONTH, DAY, YEAR], pulled from constants
 * @returns {InputState} The initial state of the input
 */
const getInitialState = (config, inputType) => {
  return {
    // stored as a reference to decide when onChange should be called
    initialValue: config.initialValue,
    // if we have an initialValue, use it. otherwise default to an empty string
    value: config.initialValue ? config.initialValue : '',
    // determines whether or not the consumer is notified of updates
    touched: false,
    // if we have an initialValue, validate it and set the error message or an empty string
    // will not check for missing required values at this point
    error: config.initialValue && (0, _validation.validateInput)(inputType, config.initialValue) ? '' : config.invalidMsg,
    // error should be visible if initial value exists; otherwise wait for onChange
    isErrorVisible: config.initialValue && config.initialValue !== '' ? true : false,
    lastEventType: ''
  };
};

/**
 * Returns true if all of the inputs have been touched (blurred). If a given input
 * has an initial value passed in the config from the consumer, then that input is
 * also considered to be touched; touched will be true when its initial state is
 * generated above.
 *
 * @param {Object} monthState the current state of the month input
 * @param {Object} dayState the current state of the day input
 * @param {Object} yearState the current state of the year input
 * @returns {Boolean}
 */
exports.getInitialState = getInitialState;
const allInputsTouched = (monthState, dayState, yearState) => {
  return monthState.touched && dayState.touched && yearState.touched;
};

/**
 * Returns true if all of the inputs have values (either initial values
 * or values set by user).
 *
 * @param {InputState[]} inputStates
 * @returns {Boolean}
 */
exports.allInputsTouched = allInputsTouched;
const allInputsHaveValues = function () {
  for (var _len = arguments.length, inputStates = new Array(_len), _key = 0; _key < _len; _key++) {
    inputStates[_key] = arguments[_key];
  }
  return (0, _every.default)(inputStates).call(inputStates, inputState => Boolean(inputState.value || inputState.initialValue));
};

/**
 * Determines whether or not the consumer should be notified of updates.
 * Checks whether field values have changed and/or been touched.
 *
 * @param {InputState[]} inputStates
 * @returns {Boolean}
 */
exports.allInputsHaveValues = allInputsHaveValues;
const shouldUpdateParent = function () {
  for (var _len2 = arguments.length, inputStates = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    inputStates[_key2] = arguments[_key2];
  }
  return (0, _some.default)(inputStates).call(inputStates, state => isChanged(state) || isTouched(state));
};
exports.shouldUpdateParent = shouldUpdateParent;
const isChanged = state => Boolean(state.initialValue !== state.value);
const isTouched = state => Boolean(state.touched);

/**
 * Returns a valid date object if one can be created given the current inputs,
 * otherwise returns null.
 *
 * @param {String} month The current value of month from state
 * @param {String} day The current value of day from state
 * @param {String} year The current value of year from state
 * @returns {Object|Null} A valid Date object if one can be created
 */
const getValidDate = (month, day, year) => {
  const monthNum = Number(month);
  const dayNum = Number(day);
  const yearNum = Number(year);
  let dateResult = null;
  if ((0, _validation.validateDate)(month, day, year)) {
    const dateObject = new Date(yearNum, monthNum - 1, dayNum);
    // in the case of leap years, this check will not pass
    if (dateObject.getMonth() === monthNum - 1) {
      dateResult = dateObject;
    }
  }
  return dateResult;
};

/**
 * This builds the data object passed to the consumer's callback function. If
 * a valid date object cannot be created, then dateObject will be null.
 *
 * @param {Date} dateObject A valid date object or null
 * @param {Object} monthState The state of the month input
 * @param {Object} dayState The state of the day input
 * @param {Object} yearState The state of the year input
 * @returns {Object} The object passed to the consumer's callback function
 */
exports.getValidDate = getValidDate;
const buildDateResponseObject = (dateObject, monthState, dayState, yearState) => {
  let errors = [];
  if (monthState.error && monthState.error !== '') {
    errors.push(monthState.error);
  }
  if (dayState.error && dayState.error !== '') {
    errors.push(dayState.error);
  }
  if (yearState.error && yearState.error !== '') {
    errors.push(yearState.error);
  }
  return {
    date: dateObject,
    month: monthState.value,
    day: dayState.value,
    year: yearState.value,
    errors: errors
  };
};
exports.buildDateResponseObject = buildDateResponseObject;